import { Flex } from "@chakra-ui/react";

import { CompositeSwatch } from "./components/composite-swatch";
import { SimpleSwatch } from "./components/simple-swatch";
import { SpriteSwatch } from "./components/sprite-swatch";
import { GroupIcon } from "./components/swatch-group-icon";

export const Swatch = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex position="relative" w={6} flexShrink={0} alignItems="center" justifyContent="center">
      {children}
    </Flex>
  );
};

Swatch.Simple = SimpleSwatch;
Swatch.Composite = CompositeSwatch;
Swatch.Sprite = SpriteSwatch;
Swatch.GroupIcon = GroupIcon;
